import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import arrowRight from "../logos/Arrow.png";
import arrowLeft from "../logos/Arrow1.png";
import videoData from "../videoData.json";

const VideoSlider = () => {
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleSwiper = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <div className="video-slider-wrapper" dir="rtl">
      <div className="slider-header">
        <h2 className="slider-title">
          וידאו-טיפ: מה חשוב לדעת על מה שאתם רואים כאן?
        </h2>
        <div className="slider-buttons">
          <div className="swiper-button-prev-custom">
            <img src={arrowRight} alt="הקודם" />
          </div>
          <div className="swiper-button-next-custom">
            <img src={arrowLeft} alt="הבא" />
          </div>
        </div>
      </div>

      <div className="swiper-container-fade">
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          spaceBetween={20}
          slidesPerView="auto"
          centeredSlides={false}
          grabCursor={true}
          dir="rtl"
          onSwiper={handleSwiper}
          onSlideChange={handleSlideChange}
        >
          {videoData.map((video, index) => (
            <SwiperSlide key={index} className="video-slide">
              <div
                className="video-card"
                onClick={() => {
                  setSelectedVideo(video.videoSrc);
                  setPopupOpen(true);
                }}
                style={{ cursor: "pointer" }}
              >
                <img src={video.thumbnail} alt="" className="bg_img" />
                <span className="duration">{video.duration}</span>
              </div>
              <div className="video-footer">{video.title}</div>
            </SwiperSlide>
          ))}
        </Swiper>

        {!isBeginning && isEnd && <div className="fade-overlay fade-left"></div>}
        {!isEnd && <div className="fade-overlay fade-right"></div>}
      </div>

      {popupOpen && selectedVideo && (
        <div className="video-popup-overlay" onClick={() => setPopupOpen(false)}>
          <div className="video-popup" onClick={(e) => e.stopPropagation()}>
            <video
              width="100%"
              height="100%"
              controls
              autoPlay
              src={selectedVideo}
              style={{ borderRadius: "8px" }}
            />
            <button className="close-btn" onClick={() => setPopupOpen(false)}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoSlider;
